import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onBeforeMount, ref, watch } from 'vue';
import { Tag } from '@/interfaces/model/general/tag';
import { useTagComposable } from '@/composables/useTag';
import TagChip from '@/components/TagChip.vue';
import sharedMessages from '@/lib/shared-messages';
import VSelect from 'vuetify/lib/components/VSelect/VSelect';

interface CustomTag extends Tag {
  selected?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedTagsAutocomplete',
  props: {
    fileName: null,
    selectedTagIds: null,
    tags: null
  },
  emits: ["updateTags"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'updateTags', tags: Tag[], fileName: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  fileName: string;
  selectedTagIds?: number[];
  tags?: Tag[];
};





const { tags: tagsFromComposable, getCompanyTag } = useTagComposable();
const isLoading = ref<boolean>(true);
const isMenuOpen = ref<boolean>(false);
const defaultTags = ref<CustomTag[]>([]);
const selectedTags = ref<CustomTag[]>([]);
const searchKeyword = ref<string>('');
const selectInput = ref<InstanceType<typeof VSelect> | null>(null);

const currentUrl = window.location.href;
const baseUrl = currentUrl.split('#')[0];
const newPath = '#/dashboard/company/tags';
const tagListUrl = `${baseUrl}${newPath}`;

const tags = computed(() => props.tags || tagsFromComposable.value);

const filteredTags = computed(() => {
  const searchedTags = defaultTags.value.filter((tag) =>
    tag.name.toLowerCase().includes(searchKeyword.value.toLowerCase())
  );
  return searchKeyword.value.length ? searchedTags : defaultTags.value;
});

const updateTempTags = (tag: Tag) => {
  if (selectedTags.value.some((selectedTag) => selectedTag.id === tag.id)) {
    removeTag(tag.id);
  } else {
    selectedTags.value = [...selectedTags.value, tag];
    defaultTags.value = defaultTags.value.map((defaultTag) =>
      defaultTag.id === tag.id ? { ...defaultTag, selected: true } : defaultTag
    );
  }
};

const removeTag = (tagId: number) => {
  selectedTags.value = selectedTags.value.filter((tag) => tag.id !== tagId);
  defaultTags.value = defaultTags.value.map((defaultTag) =>
    defaultTag.id === tagId ? { ...defaultTag, selected: false } : defaultTag
  );
};

watch(isMenuOpen, (isOpen) => {
  if (isOpen) {
    selectedTags.value = tags.value.filter((tag) =>
      props.selectedTagIds?.includes(tag.id)
    );
    defaultTags.value = tags.value.map((tag) => ({
      ...tag,
      selected: props.selectedTagIds?.includes(tag.id),
    }));
    nextTick(() => {
      // メニューが開いたら検索フォームにフォーカスを当てる
      setTimeout(() => {
        if (selectInput.value) {
          selectInput.value.isMenuActive = true;
        }
      }, 50);
    });
  } else {
    /** selectedを除外し正規化してアップデートする */
    const normalizationTags: Tag[] = selectedTags.value.map((tag) => {
      /* eslint-disable @typescript-eslint/no-unused-vars */
      const { selected, ...rest } = tag;
      return rest;
    });
    emits('updateTags', normalizationTags, props.fileName);
  }
});

onBeforeMount(async () => {
  if (!props.tags) {
    await getCompanyTag();
  }
  defaultTags.value = tags.value.map((tag) => ({
    ...tag,
    selected: props.selectedTagIds?.includes(tag.id),
  }));
  isLoading.value = false;
});

return { __sfc: true,props, emits, tagsFromComposable, getCompanyTag, isLoading, isMenuOpen, defaultTags, selectedTags, searchKeyword, selectInput, currentUrl, baseUrl, newPath, tagListUrl, tags, filteredTags, updateTempTags, removeTag, TagChip, sharedMessages, VSelect }
}

})